<template>
  <div class="card" v-if="loaded">
    <template v-if="showHeader">
      <h3 class="bold text-primary" style="margin-bottom:6px">{{$t("My agenda")}}</h3>
      <hr class="text-primary" />
    </template>
    <div class="md-layout">
      <div class="md-layout md-layout-item md-size-100">
        <div class="ml-auto">
          <div v-if="hasAgendaAccess">
            <md-button
              @click.prevent="print"
              class="md-round md-primary md-sm md-blue-border"
              style="margin:0px"
            >{{$t('Download PDF')}}</md-button>
          </div>
        </div>
      </div>

      <div class="md-layout-item md-size-100" style="margin: 10px 0px">
        <md-checkbox v-model="showRecommended" style="margin-left:2px">
          <md-icon class="text-primary" style="margin-right:-1px;font-size:22px !important">star</md-icon>
          {{$t('Recommended events')}}
        </md-checkbox>
        <md-checkbox v-model="showMine" style="margin-left:2px">
          <md-icon
            class="text-primary"
            style="margin-right:-1px;font-size:22px !important"
          >person_outline</md-icon>
          {{$t('My speeches')}}
        </md-checkbox>
        <md-checkbox v-model="showLiked" style="margin-left:2px">
          <md-icon
            class="text-primary"
            style="margin-right:-1px;font-size:22px !important"
          >add_circle</md-icon>
          {{$t('Bookmarked events')}}
        </md-checkbox>
      </div>
      <div class="md-layout-item md-size-100 md-layout" v-if="model.dates.length">
        <tabs
          :tab-active="1"
          :tab-name="model.dates"
          :tab-title="tabTitles"
          plain
          color-button="primary"
        >
          <div
            v-for="(date, index) in model.dates"
            :key="date"
            :slot="getTabName(index+1)"
            style="padding-top:10px"
          >
            <template v-if="getPanelsByDate(date).length">
              <item
                v-for="panel in getPanelsByDate(date)"
                :key="panel.id"
                :item="panel"
                showThematicPath="true"
                showDetailsLink="true"
              />
            </template>
            <no-data v-else />
          </div>
        </tabs>
      </div>
      <no-data v-else class="md-layout-item md-size-100" />
      <div class="md-layout md-layout-item md-size-100" v-if="showFooter">
        <div class="ml-auto">
          <div v-if="hasAgendaAccess">
            <md-button
              @click.prevent="$router.push({name:'panels'})"
              class="md-round md-primary md-sm md-blue-border"
              style="margin:0px"
            >{{$t('Show agenda')}}</md-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "@/util/axios";
import { mapGetters, mapActions } from "vuex";
import { Tabs } from "@/components";
import NoData from "@/pages/authenticated/NoData";

import Item from "@/pages/authenticated/components/Agenda/PanelListItem";

export default {
  components: { Tabs, Item, NoData },
  props: ["showHeader", "showFooter"],
  computed: {
    ...mapGetters({
      language: "language/current",
      conference: "conference/current",
      hasAgendaAccess: "user/hasAgendaAccess",
      hasAttendeesAccess: "user/hasAttendeesAccess",
      hasChatAccess: "user/hasChatAccess",
      agendaSettings: "user/agendaSettings"
    }),
    avatarUrl() {
      return axios.getAttendeeAvatarUrl(
        this.conference.year,
        this.conference.type,
        this.model.externalId
      );
    },

    tabTitles: function() {
      return this.model.dates.map((d, i) =>
        this.agendaSettings.showDate
          ? `${this.$t("Day")} ${i + 1} (${this.$moment(d).format(
              "YYYY-MM-DD"
            )})`
          : `${this.$t("Day")} ${i + 1}`
      );
    }
  },
  data() {
    return {
      loaded: false,
      activeTab: 0,
      model: {
        dates: [],
        items: []
      },
      showLiked: true,
      showMine: true,
      showRecommended: true
    };
  },
  methods: {
    async loadData() {
      this.model = (
        await axios.get("public/conferences/conference/myagenda", {
          params: {
            year: this.conference.year,
            type: this.conference.type,
            language: this.language.code
          }
        })
      ).data;
      this.activeTab = 1;
      this.loaded = true;
    },
    getTabName(index) {
      return "tab-pane-" + index + "";
    },
    getPanelsByDate(date) {
      return this.model.items
        .filter(
          e =>
            e.date === date &&
            ((this.showLiked && e.isLiked) ||
              (this.showMine && e.isMine) ||
              (this.showRecommended && e.isRecommended))
        )
        // Komparator MUSI zwracac liczbe - poprzednia wersja zwracala true/false
        // (i miala zamienione argumenty), przez co kolejnosc byla przypadkowa.
        // Chronologicznie: najblizsze wydarzenie pierwsze.
        .sort((a, b) => {
          if (a.startDate !== b.startDate) return a.startDate < b.startDate ? -1 : 1;
          if (a.endDate !== b.endDate) return a.endDate < b.endDate ? -1 : 1;
          return 0;
        });
    },
    imgNotLoaded(event) {
      if (!this.imgLoaded) {
        event.target.src = require("@/assets/img/blank_avatar.png");
      }
      this.imgLoaded = true;
    },
    async print() {
      let loader = this.$loading.show({ container: this.$refs.page });

      try {
        await axios.downloadAgendaFile(
          "public/conferences/conference/printMyAgenda",
          {
            year: this.conference.year,
            type: this.conference.type,
            language: this.language.code
          }
        );
      } finally {
        loader.hide();
      }
    }
  },
  async mounted() {
    await this.loadData();
  },
  watch: {
    async language() {
      this.model.items = [];
      await this.loadData();
    }
  }
};
</script>
<style lang="scss">
.md-card-tabs .tab-content {
  padding: 0px 0px;
}

.md-card-tabs .md-list-item + .md-list-item {
  margin-left: 0px;
}

.md-card-tabs .md-list-item {
  margin-right: 2px;
}

.md-card-tabs .md-list {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: initial;
  flex-flow: initial;
  padding: 0px;
}

.md-checkbox .md-checkbox-label {
  height: 0px;
}

.md-icon {
  margin: 0px 3px;
  padding-bottom: 3px;
  font-size: 20px !important;
}

.md-checkbox .md-checkbox-label {
  font-weight: 400;
  font-size: 1rem;
  color: #aaa;
  padding-left: 5px;
}

.md-checkbox {
  width: auto;
  margin: 0px 16px 6px 0;
  display: inline-flex;
  position: relative;
}

.md-card {
  margin-bottom: 0px;
}

.md-layout-item {
  padding-right: 0px;
  padding-left: 0px;
}
</style>